import branchManagementBranchPerformanceComponent from './branch_performance.component';

let branchManagementBranchPerformanceModule = angular.module('branchManagementBranchPerformance', [])
    .component('branchManagementBranchPerformance', branchManagementBranchPerformanceComponent)
    .name;

export default branchManagementBranchPerformanceModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/branch_performance/index.js